/* ============================================================
   OneCircle Produktkarte – Smart Add-to-Cart
   Datei: assets/oc-product-card.js
   ------------------------------------------------------------
   - Init via Flag window.__ocPcAtcInit -> nur ein Click-Handler
     pro Page-Load, selbst wenn das Snippet N-mal eingebunden wird.
   - Event-Delegation auf [data-oc-pc-atc] (Buttons mit 1 Variante
     + verfügbar). Ruft den Standard-Shopify-Warenkorb auf
     (/cart/add.js). Webkul/Stripe-Cart wird NICHT umgangen –
     wir benutzen exakt denselben Endpoint, den auch Webkul nutzt.
   - Nach erfolgreichem Hinzufügen: kurzer Button-Feedback-State
     "Hinzugefügt ✓", dann zurück. /cart.js wird gepullt um den
     Theme-Cart-Bubble (Selektoren [data-cart-count]) zu
     aktualisieren; ein Custom-Event 'cart:updated' wird
     dispatchet, falls die Theme-Cart-Drawer-Logik darauf hört.
   ============================================================ */
(function () {
  if (window.__ocPcAtcInit) return;
  window.__ocPcAtcInit = true;

  var CART_ADD_URL = (window.Shopify && Shopify.routes && Shopify.routes.cart_add_url) || '/cart/add.js';
  var CART_URL    = (window.Shopify && Shopify.routes && Shopify.routes.cart_url) || '/cart.js';

  function refreshCartBubble() {
    fetch(CART_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(function () { /* still */ });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-oc-pc-atc]');
    if (!btn) return;
    // Verhindert Card-Anker-Navigation (Button steckt innerhalb des <a>)
    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled || btn.classList.contains('is-loading') || btn.classList.contains('is-success')) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var defaultLabel = btn.getAttribute('data-default-label') || 'In den Warenkorb';
    btn.classList.add('is-loading');
    btn.disabled = true;

    var form = new FormData();
    form.append('id', variantId);
    form.append('quantity', '1');

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: form
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error((err && (err.description || err.message)) || 'Hinzufügen fehlgeschlagen');
          });
        }
        return res.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        btn.textContent = 'Hinzugefügt ✓';
        refreshCartBubble();

        setTimeout(function () {
          btn.classList.remove('is-success');
          btn.textContent = defaultLabel;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        btn.textContent = 'Fehler – nochmal versuchen';

        setTimeout(function () {
          btn.classList.remove('is-error');
          btn.textContent = defaultLabel;
          btn.disabled = false;
        }, 2200);
      });
  });

  /* ==========================================================
     Quick-View-Trigger (Auge-Button, [data-oc-pc-qv])
     ----------------------------------------------------------
     Der eigentliche Modal-Open wird vom Custom Element
     <modal-component-toggler> aus assets/global.js gemacht.
     Wir sind hier nur das Safety-Net: die Karte ist ein
     <a>-Wrapper, und wir wollen absolut sichergehen, dass
     der Auge-Klick NICHT zur Produktseite navigiert - auch
     nicht, falls global.js aus irgendeinem Grund verzoegert
     lädt und der Modal-Handler noch nicht aktiv ist.
     ========================================================== */
  document.addEventListener('click', function (e) {
    var qvBtn = e.target.closest('[data-oc-pc-qv]');
    if (!qvBtn) return;
    e.preventDefault();
    e.stopPropagation();
  });
})();
